module.exports = __webpack_public_path__ + "media/images/ 13_Occitanie-99232787bd3686882430394262af81ff.svg";